export type TBufferZone = 'critical' | 'high' | 'medium' | 'low' | 'otog';

const BufferZones: TBufferZone[] = ['critical', 'high', 'medium', 'low', 'otog'];

export const BufferZonesIndex = BufferZones.reduce<Partial<Record<TBufferZone, number>>>(
  (acc, zone, index) => {
    acc[zone] = index;
    return acc;
  },
  {}
) as Record<TBufferZone, number>;

export const BufferZonesOptions = BufferZones.map((zone: TBufferZone, index: number) => {
  return { key: index, value: zone, label: zone };
});

export default BufferZones;
